module.exports = __webpack_public_path__ + "img/tunisia.881e1b1c.svg";